import { Injectable } from '@angular/core';
import {
  DcTypes,
  Feature,
  FeatureNames,
  TypedFeatureProperties,
} from '../../../../projects/client';
import { DecimalPipeWrapper } from '../../../shared/pipes/decimal-pipe-wrapper/decimal-pipe-wrapper.pipe';
import { FeatureValueStrategy } from './feature-value-strategy.model';

@Injectable({ providedIn: 'root' })
export class NumberValueStrategy implements FeatureValueStrategy {
  constructor(private decimalPipeWrapper: DecimalPipeWrapper) {}

  supports(
    feature: Feature<TypedFeatureProperties<number>, unknown>,
    propertyName: string
  ): boolean {
    return feature?.properties?.[propertyName]?.type === DcTypes.number;
  }

  transformValue(
    feature: Feature<TypedFeatureProperties<number>, unknown>,
    propertyName: string,
    digitsInfo?: string
  ): string {
    // TODO - migrate here logic from decimal Pipe Wrapper ( and potentially remove it )
    if (
      feature.feature === FeatureNames.cascadeMemberId ||
      feature.feature === FeatureNames.fuelCellStatistics // separate strategy would be best, (e.g. localization missing )
    ) {
      return feature.properties?.[propertyName]?.value?.toString();
    }

    return this.decimalPipeWrapper.transform(feature.properties?.[propertyName]?.value, digitsInfo);
  }
}
